import {btn, comp, Component, h3, p, t} from "@intermesh/goui";

export class NotFound extends Component {
	constructor() {
		super("section");
		this.itemId = "not-found";
		this.id = "not-found";
		this.cls = "ifw-card";
		this.height = 400;


		this.items.add(
			comp({cls: "vbox"}),
			comp({flex: 1}),
			comp({cls: "hbox ifw-center padding-bottom"},
				comp({cls: "go-48 icon go-elearning-incident", tagName: "i", html: "warning"})),
			comp({cls: "hbox ifw-center"},
				h3({cls: "ifw-title", html: t("Not found")})),
			comp({cls: "hbox ifw-center"},
				p({html: t("")})),
			comp({cls: "hbox ifw-center"},
				p({html: t("The page you requested was not found")})),
			comp({cls: "hbox ifw-center"},
				btn({cls: "primary", text: t("start"), route: ""})),
			comp({flex: 1})
		);

	}
}